import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import ArgonDashboard from "./argon-dashboard";
import interceptorsSetup from './router/interceptores';
interceptorsSetup()
import axios from 'axios'
// axios.defaults.baseURL = 'http://192.168.1.149/apieasyturno/public/index.php/';
// axios.defaults.baseURL = 'http://192.168.52.54:81/apieasyturno/public/index.php/';
axios.defaults.baseURL = 'https://apidigiturno.notariakoripaulett.com/public/index.php/';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';


const appInstance = createApp(App);
appInstance.use(store);
appInstance.use(router);
appInstance.use(ArgonDashboard);
// appInstance.use(axios);
appInstance.use(VueSweetalert2);
appInstance.mount("#app");
